
import React from "react";
import { TYPE_OPTIONS, GENDER_OPTIONS, AGE_OPTIONS, VEHICLE_OPTIONS, RANDOM_COLORS } from "./SearchConstants";
import { RadioButton, RadioButtonGroup } from "@vds/radio-buttons";
import { Checkbox } from "@vds/checkboxes";
import { ClothingColorBlocks } from "../../global/components/ClothingColorBlocks/ClothingColorBlocks";
import "./search.css";

const Search_What = ({
  type,
  setType,
  gender,
  setGender,
  age,
  setAge,
  vehicle,
  setVehicle,
  upperColors,
  setUpperColors,
  lowerColors,
  setLowerColors,
  vehicleColors,
  setVehicleColors,
}) => {
  const handleTypeChange = (e) => {
    const newType = e.target.value;
    if (type !== newType) {
      setType(newType);
      if (newType === "person") {
        setGender([]);
        setAge([]);
        setUpperColors([]);
        setLowerColors([]);
      } else {
        setVehicle([]);
      }
    }
  };

  const handleUpperColorToggle = (colorObj) => {
    setUpperColors((prev) =>
      prev.some((c) => c.hex === colorObj.hex)
        ? prev.filter((c) => c.hex !== colorObj.hex)
        : [...prev, colorObj]
    );
  };

  const handleLowerColorToggle = (colorObj) => {
    setLowerColors((prev) =>
      prev.some((c) => c.hex === colorObj.hex)
        ? prev.filter((c) => c.hex !== colorObj.hex)
        : [...prev, colorObj]
    );
  };

  const handleCheckboxChange = (option, state, setState) => {
    setState((prev) =>
      prev.includes(option)
        ? prev.filter((item) => item !== option)
        : [...prev, option]
    );
  };

  return (
    <div className="whatWrapper">
      <h3 className="labelStyle">Type</h3>
      <RadioButtonGroup value={type} onChange={handleTypeChange}>
        {TYPE_OPTIONS.map((opt) => (
          <RadioButton
            key={opt.value}
            value={opt.value}
            label={<span className="labelStyle">{opt.label}</span>}
            className="radioInline"
          />
        ))}
      </RadioButtonGroup>

      {type === "person" && (
        <>
          <div className="labelStyle" style={{ marginBottom: "8px" }}>
            Gender appearance <span className="optionalLabel">Optional</span>
          </div>
          <div className="checkboxGroup">
            {GENDER_OPTIONS.map((opt) => (
              <Checkbox
                key={opt.value}
                selected={gender.includes(opt.value)}
                onChange={() => handleCheckboxChange(opt.value, gender, setGender)}
                label={<span className="labelStyle">{opt.label}</span>}
              />
            ))}
          </div>
          <div className="labelStyle" style={{ marginBottom: "8px" }}>
            Age appearance <span className="optionalLabel">Optional</span>
          </div>
          <div className="checkboxGroup">
            {AGE_OPTIONS.map((opt) => (
              <Checkbox
                key={opt.value}
                selected={age.includes(opt.value)}
                onChange={() => handleCheckboxChange(opt.value, age, setAge)}
                label={<span className="labelStyle">{opt.label}</span>}
              />
            ))}
          </div>
          <div className="colorBlockWrapper">
            <div className="labelStyle">
              Upper clothing color <span className="optionalLabel">Optional</span>
              <span
                className="selectAllLink"
                onClick={() => setUpperColors(upperColors.length === RANDOM_COLORS.length ? [] : [...RANDOM_COLORS])}
              >
                Select all
              </span>
            </div>
            <ClothingColorBlocks
              colors={RANDOM_COLORS}
              selectedColors={upperColors}
              onToggle={handleUpperColorToggle}
              testId="upper-clothing-color"
            />
            <div className="selectedColorsLabel">
              <span className="selectedLabel">Selected:</span>{" "}
              {upperColors.length === 0
                ? <span className="selectedColorName">no colors selected</span>
                : upperColors.map((colorObj, idx) => (
                  <span className="selectedColorName" key={colorObj.hex}>
                    {colorObj.name}{idx < upperColors.length - 1 ? ", " : ""}
                  </span>
                ))}
            </div>
          </div>
          <div className="colorBlockWrapper">
            <div className="labelStyle">
              Lower clothing color <span className="optionalLabel">Optional</span>
              <span
                className="selectAllLink"
                onClick={() => setLowerColors(lowerColors.length === RANDOM_COLORS.length ? [] : [...RANDOM_COLORS])}
              >
                Select all
              </span>
            </div>
            <ClothingColorBlocks
              colors={RANDOM_COLORS}
              selectedColors={lowerColors}
              onToggle={handleLowerColorToggle}
              testId="lower-clothing-color"
            />
            <div className="selectedColorsLabel">
              <span className="selectedLabel">Selected:</span>{" "}
              {lowerColors.length === 0
                ? <span className="selectedColorName">no colors selected</span>
                : lowerColors.map((colorObj, idx) => (
                  <span className="selectedColorName" key={colorObj.hex}>
                    {colorObj.name}{idx < lowerColors.length - 1 ? ", " : ""}
                  </span>
                ))}
            </div>
          </div>
        </>
      )}

      {type === "vehicle" && (
        <>
          <div className="labelStyle" style={{ marginBottom: "8px" }}>
            Vehicle <span className="optionalLabel">Optional</span>
          </div>
          <div className="checkboxGroup">
            {VEHICLE_OPTIONS.map((opt) => (
              <Checkbox
                key={opt.value}
                selected={vehicle.includes(opt.value)}
                onChange={() => handleCheckboxChange(opt.value, vehicle, setVehicle)}
                label={<span className="labelStyle">{opt.label}</span>}
              />
            ))}
          </div>
          <div className="colorBlockWrapper">
            <div className="labelStyle">
              Vehicle color <span className="optionalLabel">Optional</span>
              <span
                className="selectAllLink"
                onClick={() => setVehicleColors(vehicleColors.length === RANDOM_COLORS.length ? [] : [...RANDOM_COLORS])}
              >
                Select All
              </span>
            </div>
            <ClothingColorBlocks
              colors={RANDOM_COLORS}
              selectedColors={vehicleColors}
              onToggle={(colorObj) =>
                setVehicleColors((prev) =>
                  prev.some((c) => c.hex === colorObj.hex)
                    ? prev.filter((c) => c.hex !== colorObj.hex)
                    : [...prev, colorObj]
                )
              }
              testId="vehicle-color"
            />
            <div className="selectedColorsLabel">
              <span className="selectedLabel">Selected:</span>{" "}
              {vehicleColors.length === 0
                ? <span className="selectedLabel">no colors selected</span>
                : vehicleColors.map((colorObj, idx) => (
                  <span className="selectedColorName" key={colorObj.hex}>
                    {colorObj.name}{idx < vehicleColors.length - 1 ? ", " : ""}
                  </span>
                ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Search_What;